const soundTrivia = ()=>{
    const audio = document.querySelector('#sound-trivia');
    const audioStadium = document.querySelector('#sound-stadium');
    const body = document.querySelector('body');
    const validateStopAudio = document.querySelector('.stop-audio-preview');
    body.addEventListener('click', ()=>{
        if(document.querySelector('#trivia-resume').classList.contains('hidden')){
            if(!body.classList.contains('active-sound')){
                audioStadium && audioStadium.remove();
                validateStopAudio && validateStopAudio.classList.remove('stop-audio')
                audio.play();
                audio.classList.add('active');
            }
        }
        body.classList.add('active-sound');
    });
}

const SoundStadium = ()=>{
    const audio = document.querySelector('#sound-stadium');
    const audioTrivia = document.querySelector('#sound-trivia');
    const body = document.querySelector('body');
    const validateStopAudio = document.querySelector('.stop-audio-preview');
    //Replay audio in trivia pages
    body.addEventListener('click', ()=>{
        if(!body.classList.contains('active-sound')){
            audioTrivia && audioTrivia.remove(); 
            console.log(validateStopAudio);
            validateStopAudio && validateStopAudio.classList.remove('stop-audio')
            audio && audio.play();
            audio && audio.classList.add('active');
        }
        body.classList.add('active-sound');
    });
}

const SoundStop = ()=>{
    const stopSound = document.querySelector('#stop-sound');
    stopSound && stopSound.addEventListener('click', ()=>{
        stopSound.classList.toggle('stop-audio');
        document.querySelectorAll('audio').forEach((audio)=>{
            if(stopSound.classList.contains('stop-audio')){
                audio.pause();
            }else{
                audio.classList.contains('active') && audio.play();
            }
        });
    });
}

const SoundStopAll = ()=>{
    document.querySelectorAll('audio').forEach((audio)=>{
        audio.pause();
    });
}

const SoundButton = ()=>{
    const buttons = document.querySelectorAll('.btn-sound');
    const audio = document.querySelector('#sound-button');
    //Event
    buttons.forEach((button)=>{
        button.addEventListener('click', (e)=>{
            audio && audio.play();
            setTimeout(()=>{
                audio && audio.pause();
                audio && (audio.currentTime = 0);
            },500);
        });
    });
}

const SoundAnswer = ()=>{
    const audio = document.querySelector('#sound-answer');
    const questions = document.querySelectorAll('.trivia-questions input'); 
    //Event
    questions.forEach((answer)=>{
        answer.addEventListener('click', (e)=>{
            audio && audio.play();
            setTimeout(()=>{
                audio && audio.pause();
                audio && (audio.currentTime = 0);
            },500);
        });
    });
}

const SoundWinner = ()=>{
    const body = document.querySelector('body');
    const audio = document.querySelector('#sound-winner');
    body.addEventListener('click', ()=>{
        audio && audio.play();
    });
}

export { SoundButton, soundTrivia, SoundStop, SoundStopAll, SoundStadium, SoundAnswer, SoundWinner }